export default __webpack_public_path__ + "static/media/3.fa4dc8bc.png";